import { common, experienceStyles } from "./styles"
import { useAuth } from "../../AuthContext"
import { useNavigate } from "react-router-dom"
import axios from "axios"

export default function Experience({ profile }) {
  const { user } = useAuth()
  const navigate = useNavigate()
  const experiences = profile?.experience || []
  const isOwner = user && profile && user.id === profile.user_id

  const handleEditExperience = (exp) => {
    navigate("/AddWorkExperience", { state: { experienceRecord: exp } })
  }

  const handleRemoveExperience = async (experienceId) => {
    if (!window.confirm("Are you sure you want to remove this experience?")) return
    try {
      await axios.delete(`http://localhost:5000/delete-work-experience?exId=${experienceId}`)
      navigate(`/ProProject`);
    } catch (err) {
      alert("Failed to remove experience")
    }
  }

  return (
    <section style={common.section} id="experience">
      <div style={common.sectionContent}>
        <h2
          style={{
            fontSize: "3rem",
            fontFamily: common.subheading.fontFamily,
            fontWeight: 700,
            textTransform: "uppercase",
            color: "#343a40",
            marginBottom: "2rem",
          }}
        >
          Experience
        </h2>

        {experiences.length === 0 && <div>No experience records found.</div>}

        {experiences.map((exp, index) => (
          <div key={index} style={experienceStyles.item}>
            <div style={{ marginBottom: "1rem" }}>
              <h3 style={experienceStyles.title}>{exp.role}</h3>
              <div style={experienceStyles.company}>{exp.company_name}</div>
              <p>{exp.responsibilities}</p>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <span style={experienceStyles.period}>
                {exp.start_date} - {exp.end_date}
              </span>
              {isOwner && (
                <div style={{ marginLeft: "1rem", display: "flex", gap: "0.5rem" }}>
                  <button
                    onClick={() => handleEditExperience(exp)}
                    title="Edit"
                    style={{
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      fontSize: "1.1rem",
                      padding: 0,
                    }}
                  >
                    ✏️
                  </button>
                  <button
                    onClick={() => handleRemoveExperience(exp.experience_id)}
                    title="Remove"
                    style={{
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      fontSize: "1.1rem",
                      padding: 0,
                    }}
                  >
                    ❌
                  </button>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}
